import type { ActionModel, ComponentModel } from '@jet/environment';
import { type Link } from '../page';

// TODO: Use actual interface
// TODO: Add tests!
interface ContextMenuItemConfig {}

export interface AccessoryButton {
    kind: AccessoryButtonKind;
    item: AccessoryButtonItem;
}

export type AccessoryButtonKind =
    | 'default'
    | 'popover'
    | 'contextMenu'
    | 'refresh';

export type AccessoryButtonItem =
    | DefaultAccessoryButton
    | PopoverAccessoryButton
    | SortAccessoryButton
    | RefreshAccessoryButton;

export interface DefaultAccessoryButton extends ComponentModel {
    text: string;
}

export interface PopoverAccessoryButton extends ComponentModel {
    items: Link[];
    selectedItemID: string;
}

export interface SortAccessoryButton extends ComponentModel {
    items: ContextMenuItemConfig[];
    sortBy: string;
    sortOrderAction: {
        url: string;
    };
    isReversible: boolean;
}

export interface RefreshAccessoryButton extends ComponentModel {
    ariaLabel: string;
}

export interface DefaultAccessory extends AccessoryButton {
    kind: 'default';
    item: DefaultAccessoryButton;
}

export interface SortAccessory extends AccessoryButton {
    kind: 'contextMenu';
    item: SortAccessoryButton;
}

export interface RefreshAccessory extends AccessoryButton {
    kind: 'refresh';
    item: RefreshAccessoryButton;
}

export function makeDefaultAccessoryButton(
    id: string,
    text: string,
    segue: ActionModel,
): AccessoryButton {
    return {
        kind: 'default',
        item: {
            id,
            text,
            segue,
        },
    };
}

export function makePopoverAccessoryButton(
    id: string,
    items: Link[],
    selectedItemID: string,
): AccessoryButton {
    return {
        kind: 'popover',
        item: {
            id,
            items,
            selectedItemID,
        },
    };
}

export function makeSortAccessoryButton(
    id: string,
    sortConfig: {
        items: ContextMenuItemConfig[];
        sortBy: string;
        sortOrderAction: any;
    },
): AccessoryButton {
    return {
        kind: 'contextMenu',
        item: {
            id,
            ...sortConfig,
        },
    };
}

export function makeRefreshAccessoryButton(
    id: string,
    ariaLabel: string,
    segue: ActionModel,
): AccessoryButton {
    return {
        kind: 'refresh',
        item: {
            id,
            ariaLabel,
            segue,
        },
    };
}
